// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1EZNm","large":"styles_large__2sr3N"};